<div id="page-wrapper" class="login-page-wrapper">
  <mobile-warning-overlay></mobile-warning-overlay>
  <loader *ngIf="(isDemoLoading$ | async)"></loader>
  <div forbidden-breakpoint *ngIf="!(isDemoLoading$ | async)" class="container">
    <div class="row">
      <div class="col-lg-8 col-md-10 col-lg-offset-2 col-md-offset-1">
        <div class="wb-login">
          <bank-simple-login-form
            *ngIf="!isInitialPasswordReset"
          ></bank-simple-login-form>
          <bank-reset-initial-password-form
            *ngIf="isInitialPasswordReset"
          ></bank-reset-initial-password-form>
        </div>
      </div>
    </div>
  </div>
  <div
    forbidden-breakpoint
    *ngIf="!(isDemoLoading$ | async)"
    class="mobile-app-ad"
  >
    {{ 'ls_start_screen_get_mobile_message' | l10n }}
    <div class="mobile-app-ad__buttons-wrapper">
      <mobile-button [type]="'android'"></mobile-button>
      <mobile-button [type]="'ios'"></mobile-button>
    </div>
  </div>
</div>
